module.exports = __webpack_public_path__ + "static/ferie 2023-001deb736f909467720158963c617f53.png";